import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import PublishedDashboard from './PublishedDashboard';
import { MeasureListContextProvider } from '../../contexts/MeasureListContext';
// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const RootStyle = styled('div')({
    display: 'flex',
    //minHeight: '100%',
    overflow: 'hidden'
});

const MainStyle = styled('div')(({ theme }) => ({
    flexGrow: 1,
    overflow: 'auto',
    //minHeight: '100%',
}));

// ----------------------------------------------------------------------

export default function PublishedDashboardLayout(props) {
    return (
        <RootStyle>
            <MeasureListContextProvider>
                <MainStyle>
                    <Outlet />
                    <PublishedDashboard />
                </MainStyle>
            </MeasureListContextProvider>
        </RootStyle >
    );
}
